import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'Jogos Online Grátis para Jogar Sem Baixar | Gamezop',
  desc: 'Jogos online grátis para jogar, que não precisam baixar e instalar, disponíveis no Gamezop. Aproveite 200+ melhores jogos online grátis para PC e celular, incluindo ação, aventura, arcade, quebra-cabeças, corrida e muito mais.',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'Jogos Online Grátis para Jogar Sem Baixar',
    body: {
      text: [
        `Jogue os melhores jogos online grátis no Gamezop sem precisar baixar!
        Escolha seu jogo favorito da lista e comece a jogar em segundos. Temos mais de 200+ jogos grátis populares em categorias como ação, aventura, arcade, quebra-cabeça, corrida e muito mais. Seja no celular, PC ou iOS, Gamezop tem os melhores jogos para você!`,
        `Se estiver entediado, Gamezop oferece infinitas opções de diversão. Construa defesas contra inimigos, atire em alvos ou pule obstáculos. Experimente jogos emocionantes como Kingdom Fight, City Cricket, Fruity Fiesta e muitos outros! Nossos jogos são adequados para todas as idades, incluindo crianças, adultos e idosos.`,
        `Você não precisa de um dispositivo caro para jogar. Nossos jogos funcionam sem instalação ou download – tudo o que você precisa é de um navegador e conexão com a internet. Jogue no desktop, laptop, Chromebook, smartphone, tablet e muito mais.`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: `Quais são os melhores jogos online gratuitos?`,
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Quais são os jogos online grátis para jogar com amigos?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Quais são os gêneros de jogos online mais populares?',
    body: {
      text: [],
      list: [
        {
          name: 'Jogos loucos',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'Jogos de tabuleiro',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'Jogos de aventura',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'Jogos de quebra-cabeça',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'Jogos de tiro',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'O que é a Gamezop?',
    body: {
      text: [
        `A Gamezop é uma plataforma de jogos plug-and-play que permite que aplicativos e sites integrem jogos casuais de forma prática, aumentando o engajamento dos usuários. Além dos jogos, a Gamezop também gerencia diversas plataformas especializadas: Quizzop para quizzes interativos, Astrozop para previsões e insights astrológicos, Criczop para placares ao vivo de críquete e atualizações, e Feedzop para agregação de notícias selecionadas. Juntas, essas plataformas oferecem um conjunto diversificado de soluções de conteúdo que atendem a diferentes interesses do público.`,
        `Com mais de 8.000 integrações em mais de 70 países, a Gamezop e suas plataformas associadas são confiáveis por marcas globais como Amazon, Samsung Internet, Snap, Tata Play, AccuWeather e Paytm. Essas soluções não apenas impulsionam o engajamento dos usuários, mas também desbloqueiam novas oportunidades de receita. A integração é rápida, levando apenas 30 minutos, e capacita aplicativos e sites com conteúdo envolvente que inclui jogos, quizzes, astrologia, críquete e notícias.`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'FAQs',
  faqs: [
    {
      tag: 'h3',
      title: 'Posso jogar jogos grátis sem instalar?',
      body: ['Sim, você pode jogar jogos grátis sem instalar ou baixar nada.'],
    },
    {
      tag: 'h3',
      title: 'Preciso me cadastrar para jogar?',
      body: [
        `Não, você não precisa se cadastrar para jogar no Gamezop.com. Você pode começar a jogar instantaneamente, sem necessidade de registro.`,
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/pt',
      },
    },
    {
      tag: 'h3',
      title: `É seguro jogar jogos online?`,
      body: [
        'Sim, é seguro jogar jogos online em plataformas confiáveis como o Gamezop. Nossos jogos não precisam de downloads, o que minimiza os riscos de malware. Priorizamos a segurança do usuário e garantimos uma experiência de jogo segura, sem comprometer sua privacidade ou a segurança do seu dispositivo.',
      ],
    },
    {
      tag: 'h3',
      title: 'Os jogos grátis são realmente grátis?',
      body: [
        'Sim, os jogos grátis são verdadeiramente grátis para jogar no Gamezop. No entanto, esses jogos podem exibir anúncios para apoiar a plataforma.',
      ],
    },
    {
      tag: 'h3',
      title: 'Existem jogos grátis para idosos online?',
      body: [
        'Sim, temos jogos grátis para idosos que podem ser jogados online, incluindo Sudoku Classic, Solitaire Gold, Chess Grandmaster e muitos outros.',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
